import React from 'react';
import DynamicCard from '../DynamicCard';
import MediaShuttleHero from './MediaShuttle-Hero-Fixed.png';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { useMediaQueries } from '../../hooks/useMediaQueries';

const useStyles = makeStyles({
    flexBox: {
        margin: '0em 0em 5em 0em',
    },
    typography: {
        paddingRight: '3em',
        height: '100%',
    },
    mobileTypography: {
        marginTop: '1em',
        height: '100%',
    },
    heroImage: {
        marginTop: '-3em',
    },
    mobileHeroImage: {
        maxHeight: '300px',
    },
    card: {
        marginRight: '1em',
    },
    fullWidthCard: {
        width: '100%',
        marginBottom: '1em',
    },
});

// Landing page card content
const cardInformation = {
    aboutMediaShuttle: {
        title: 'Overview',
        path: '/media-shuttle/general/deployment-guide',
        content:
            'Learn more about Media Shuttle deployment strategies, \
            and a high-level overview of how it can integrate with your workflow.',
    },
    systemRequirements: {
        title: 'System Requirements',
        path: '/media-shuttle/general/system-requirements',
        content: 'View the system requirements for the Signiant SDCX Server and the Signiant App.',
    },
};

export default () => {
    const classes = useStyles();
    const isMediumDisplay = useMediaQueries('md');
    return (
        <>
            <Box
                className={classes.flexBox}
                display="flex"
                flexDirection={!isMediumDisplay ? 'row' : 'column-reverse'}
                alignItems="flex-start"
            >
                <Box flexBasis="60%" className={!isMediumDisplay ? classes.typography : classes.mobileTypography}>
                    <Typography variant="p">
                        Media Shuttle is the easiest and most reliable way for people to send any size file, anywhere,
                        fast. Sending files with Media Shuttle is as simple as dragging and dropping them onto a web
                        page. Media Shuttle’s proven file acceleration technology speeds up transfers over public and
                        private networks up to 100 times faster than standard transfer methods with minimal latency.
                    </Typography>
                </Box>
                <Box flexBasis="40%" display="flex" justifyContent="flex-end" flexDirection="row">
                    <img
                        className={!isMediumDisplay ? classes.heroImage : classes.mobileHeroImage}
                        src={MediaShuttleHero}
                        alt="Media Shuttle Hero"
                    />
                </Box>
            </Box>
            <Box display="flex" flexDirection={!isMediumDisplay ? 'row' : 'column'} alignItems="flex-start">
                <Box flexBasis="50%" className={!isMediumDisplay ? classes.card : classes.fullWidthCard}>
                    <DynamicCard {...cardInformation.aboutMediaShuttle} />
                </Box>
                <Box flexBasis="50%" className={!isMediumDisplay ? null : classes.fullWidthCard}>
                    <DynamicCard {...cardInformation.systemRequirements} />
                </Box>
            </Box>
        </>
    );
};
